import React, { useEffect, useRef } from 'react';
import './About.css';
import BackToTop from './BackToTop';
import ButtonZap from '../components/ButtonZap';
import CountUp from '../components/CountUp';
import background from '../imgs/modelo1.webp';

function About() {
  const fadeRefs = useRef([]);

  // Header claro e reativo ao scroll
  useEffect(() => {
    const header = document.querySelector('header');
    if (!header) return;

    const handleScrollHeader = () => {
      if (window.scrollY > 100) header.classList.remove('light');
      else header.classList.add('light');
    };

    header.classList.add('light');
    window.addEventListener('scroll', handleScrollHeader);
    return () => {
      window.removeEventListener('scroll', handleScrollHeader);
      header.classList.remove('light');
    };
  }, []);

  // Efeito progressivo de fade conforme o scroll
  useEffect(() => {
    const handleScroll = () => {
      fadeRefs.current.forEach((el) => {
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const progress = Math.min(Math.max(0, (windowHeight - rect.top) / (windowHeight * 0.8)), 1);

        el.style.opacity = progress;
        el.style.transform = `translateY(${50 - progress * 50}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // inicializa na carga

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="About">
      <main
        className="about-section"
        style={{
          backgroundImage: `url(${background})`,
        }}
      >
        <div className="overlay"></div>

        <div className="about-content">
          {/* TÍTULO */}
          <div ref={(el) => (fadeRefs.current[0] = el)} className="fade-scroll">
            <h1 className="about-title">Sobre Nós</h1>
          </div>

          <div id="main-about">
            {/* CONTADORES */}
            <ul ref={(el) => (fadeRefs.current[1] = el)} className="fade-scroll">
              <li>
                <strong className="glow">
                  <CountUp endNumber={400000000} duration={4000} />
                </strong>
                <p>Milhões de imagens de documentos digitalizados e indexados.</p>
              </li>
              <li>
                <strong className="glow">
                  <CountUp endNumber={25000000} duration={4000} />
                </strong>
                <p>Milhões de documentos físicos arquivados e indexados.</p>
              </li>
              <li>
                <strong className="glow">
                  <CountUp endNumber={1500} duration={4000} />
                </strong>
                <p>Clientes atendidos nos Estados de Minas Gerais, São Paulo e Rio de Janeiro.</p>
              </li>
            </ul>

            {/* TEXTO */}
            <div ref={(el) => (fadeRefs.current[2] = el)} className="text-side fade-scroll">
              <p className="about-text">
                A <strong className="text-highlight">Cedoc</strong> é referência em{' '}
                <strong className="text-highlight">gestão documental</strong>, prestando serviços
                de excelência e garantindo alto índice de satisfação entre seus clientes.
              </p>

              <p className="about-text">
                São mais de <strong className="text-highlight">10 anos de experiência</strong>,
                com constante investimento em{' '}
                <strong className="text-highlight">inovação</strong>,{' '}
                <strong className="text-highlight">tecnologia</strong> e{' '}
                <strong className="text-highlight">segurança da informação</strong> para atender às
                novas demandas do mercado.
              </p>

              <strong className="text-strong">
                10 anos de experiência no mercado de gestão de documentos
              </strong>
            </div>
          </div>
        </div>
      </main>

      <BackToTop />
      <ButtonZap />
    </div>
  );
}

export default About;
